// Version 1
// import styled from "styled-components";
// import { ContainerStyle } from "../../style/Common.style";

// export const FooterStyle = styled.footer`
//   background: #2A3845;
//   padding: 35px 0 0;

//   a {
//      color: #fff;
//      font-size: 16px;
//      font-weight: 400;
//      transition: all 200ms linear;

//      &:hover {
//         color: #FF8500;
//      }
//   }

//   .footer-wrapper {
//     ${ContainerStyle};

//     padding: 0 15px;
//     display: flex;
//     justify-content: space-between;

//     @media ( max-width: 768px ) {
//       flex-direction: column;
//       gap: 30px;
//     }

//     .footer-links {
//       display: flex;
//       flex-wrap: wrap;
//       gap: 30px;

//       @media ( max-width: 768px ) {
//         flex-direction: column;
//         gap: 30px;
//       }
//     }

//     .footer-social-links {
//       display: flex;
//       flex-wrap: wrap;
//       gap: 30px;
//     }
//   }

//   .copy-right {
//     background: #19222B;
//     color: #586A7C;
//     margin-top: 35px;
//     padding: 10px 15px;
//     text-align: center;
//   }
// `;
// Version 2

// import styled from "styled-components";
// import { ContainerStyle } from "../../style/Common.style";

// export const FooterStyle = styled.footer`
//   background: #08182f;
//   color: #ffffff;
//   padding: 70px 0 0;

//   a {
//     color: #ffffff;
//     text-decoration: none;
//     transition: all 0.2s ease;
//   }

//   a:hover {
//     color: #ff8500;
//   }

//   p {
//     margin: 0;
//     line-height: 1.8;
//     font-size: 15px;
//   }

//   .footer-wrapper {
//     ${ContainerStyle};
//     padding: 0 15px;
//   }

//   .footer-grid {
//     display: grid;
//     grid-template-columns: 1.25fr 1fr 1fr 1fr;
//     gap: 40px;

//     @media (max-width: 992px) {
//       grid-template-columns: 1fr 1fr;
//     }

//     @media (max-width: 768px) {
//       grid-template-columns: 1fr;
//       gap: 30px;
//     }
//   }

//   .footer-column h3 {
//   font-size: 30px;
//   font-weight: 700;
//   color: #FF4D30;
//   margin-bottom: 22px;
//   position: relative;
//   line-height: 1.2;
// }

//  .footer-column h3::after {
//   content: "";
//   display: block;
//   width: 62px;
//   height: 3px;
//   background: #FF8500;
//   margin-top: 10px;
//   border-radius: 20px;
// }

// .footer-links-list a:hover {
//   color: #FF8500;
// }

//   .brand-column {
//     padding-right: 10px;
//   }

//   .footer-description {
//     color: #ffffff;
//     max-width: 330px;
//     font-size: 16px;
//     line-height: 1.85;
//   }

//   .footer-links-list,
//   .footer-contact-list,
//   .footer-legal-list {
//     display: flex;
//     flex-direction: column;
//     gap: 14px;
//   }

//   .footer-links-list a,
//   .footer-contact-list a {
//     width: fit-content;
//     font-size: 16px;
//     font-weight: 600;
//     color: #ffffff;
//   }

//   .footer-contact-list p,
//   .footer-legal-list p {
//     color: #cdd8e5;
//     font-size: 16px;
//   }

//   .footer-contact-list a:hover {
//   color: #FF8500;
// }

//   .footer-legal-list strong {
//     color: #ffffff;
//     font-weight: 700;
//   }

//   .footer-social-links {
//     display: flex;
//     flex-wrap: wrap;
//     gap: 14px;
//     margin-top: 28px;
//   }

//   .footer-social-links a {
//     width: 48px;
//     height: 48px;
//     border: 1px solid rgba(255, 255, 255, 0.2);
//     border-radius: 50%;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     background: transparent;
//     color: #ffffff;
//   }

//   .footer-social-links a svg {
//     width: 22px;
//     height: 22px;
//   }

//   .footer-social-links a:hover {
//     background: #ff8500;
//     border-color: #ff8500;
//     color: #08182f;
//   }

//   .footer-social-links a:hover svg path {
//     fill: #08182f;
//   }

//   .fmcsa-logo {
//     width: 92px;
//     max-width: 100%;
//     margin-bottom: 10px;
//     object-fit: contain;
//     background: #ffffff;
//     padding: 6px;
//     border-radius: 4px;
//   }

//   .copy-right {
//     background: #061121;
//     margin-top: 55px;
//     padding: 18px 15px;
//     border-top: 1px solid rgba(255, 255, 255, 0.08);
//   }

//   .copy-right-inner {
//     ${ContainerStyle};
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     gap: 20px;

//     @media (max-width: 768px) {
//       flex-direction: column;
//       text-align: center;
//     }
//   }

//   .copy-right p {
//     color: #9fb0bf;
//     font-size: 14px;
//   }

//   .bottom-links {
//     display: flex;
//     flex-wrap: wrap;
//     gap: 18px;

//     @media (max-width: 768px) {
//       justify-content: center;
//     }
//   }

//   .bottom-links a {
//     font-size: 14px;
//     color: #9fb0bf;
//   }

//   .bottom-links a:hover {
//     color: #ff8500;
//   }
// `;

// Version 3

import styled from "styled-components";
import { ContainerStyle } from "../../style/Common.style";

export const FooterStyle = styled.footer`
  background: #08182f;
  color: #ffffff;
  padding: 60px 0 0;

  a {
    color: #ffffff;
    text-decoration: none;
    transition: all 0.2s ease;
  }

  a:hover {
    color: #ff8500;
  }

  p {
    margin: 0;
    line-height: 1.8;
    font-size: 15px;
  }

  .footer-wrapper {
    ${ContainerStyle};
    padding: 0 15px;
  }

  .trust-badges {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-bottom: 35px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);

    span {
      background: rgba(255, 133, 0, 0.12);
      border: 1px solid rgba(255, 133, 0, 0.35);
      color: #ff8500;
      padding: 10px 16px;
      border-radius: 999px;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.2px;
    }
  }

  .footer-grid {
    display: grid;
    grid-template-columns: 1.2fr 1fr 1fr 1fr;
    gap: 40px;

    @media (max-width: 992px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 30px;
    }
  }

  .footer-column h3 {
    font-size: 30px;
    font-weight: 700;
    color: #FF8500;
    margin-bottom: 22px;
    position: relative;
    line-height: 1.2;
  }

  .footer-column h3::after {
    content: "";
    display: block;
    width: 62px;
    height: 3px;
    background: #CB1E0A;
    margin-top: 10px;
    border-radius: 20px;
  }

  .brand-column {
    padding-right: 10px;
  }

  .footer-description {
    color: #ffffff;
    max-width: 330px;
    font-size: 16px;
    line-height: 1.95;
  }

  .footer-links-list,
  .footer-contact-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .footer-links-list a,
  .footer-contact-list a {
    width: fit-content;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
  }

  .footer-links-list a:hover,
  .footer-contact-list a:hover,
  .footer-legal-list p:hover {
    color: #ff8500;
  }

  .footer-contact-list p {
    color: #cdd8e5;
    font-size: 16px;
  }

  .footer-social-links {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 28px;
  }

  .footer-social-links a,
  .footer-social-links button {
    width: 48px;
    height: 48px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    color: #ffffff;
    padding: 0;
  }

  .footer-social-links a svg,
  .footer-social-links button svg {
    width: 22px;
    height: 22px;
  }

  .footer-social-links a:hover,
  .footer-social-links button:hover {
    background: #ff8500;
    border-color: #ff8500;
    color: #08182f;
  }

  .footer-social-links a:hover svg path,
  .footer-social-links button:hover svg path {
    fill: #08182f;
  }

  .quote-btn {
    margin-top: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 12px 18px;
    background: #ff8500;
    color: #08182f !important;
    font-weight: 700 !important;
    border-radius: 10px;
  }

  .quote-btn:hover {
    background: #ffffff;
    color: #08182f !important;
  }

  .legal-card {
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    padding: 18px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .legal-card p {
    color: #cdd8e5;
    font-size: 16px;
  }

  .legal-card strong {
    color: #ffffff;
    font-weight: 700;
  }

  .fmcsa-logo {
    width: 82px;
    max-width: 100%;
    margin-bottom: 6px;
    object-fit: contain;
    background: #ffffff;
    padding: 6px;
    border-radius: 6px;
  }

  .dot-btn {
    margin-top: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    border: 1px solid rgba(255, 133, 0, 0.45);
    color: #ff8500 !important;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 700;
  }

  .dot-btn:hover {
    background: #ff8500;
    color: #08182f !important;
  }

  .copy-right {
    background: #061121;
    margin-top: 55px;
    padding: 18px 15px;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
  }

  .copy-right-inner {
    ${ContainerStyle};
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;

    @media (max-width: 768px) {
      flex-direction: column;
      text-align: center;
    }
  }

  .copy-right p {
    color: #9fb0bf;
    font-size: 14px;
  }

  .bottom-links {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;

    @media (max-width: 768px) {
      justify-content: center;
    }
  }

  .bottom-links a {
    font-size: 14px;
    color: #9fb0bf;
  }

  .bottom-links a:hover {
    color: #ff8500;
  }
`;


